angular
  .module('app')
  .directive('d3Bars', ['d3Service', '$window', '$timeout', '$filter', function(d3Service, $window, $timeout, $filter) {
    return {
      restrict: 'EA',
      scope: {
        data: '=',
        src: '='
      },
      link: function(scope, el, attrs) {
        d3Service.d3().then(function(d3) {
          var renderTimeout;
          var margin = parseInt(attrs.margin) || 20,
              barHeight = parseInt(attrs.barHeight) || 20,
              barPadding = parseInt(attrs.barPadding) || 5;

          var svg = d3.select(el[0])
            .append('svg')
            .style('width', '100%');

          $window.onresize = function() {
            scope.$apply();
          };

          scope.$watch(function() {
            return angular.element($window)[0].innerWidth;
          }, function() {
            scope.render(scope.data);
          });

          scope.$watch('data', function(newData) {
            scope.render(newData);
          }, true);

          scope.onClick = function (d) {
              console.info('d3 bar click', d);
          };

          scope.render = function(data) {

              console.log(1111, data)
            svg.selectAll('*').remove();

            if (!data) return;
            if (renderTimeout) clearTimeout(renderTimeout);

            renderTimeout = $timeout(function() {
              var width = d3.select(el[0]).node().offsetWidth - margin,
                  height = scope.data.length * (barHeight + barPadding),
                  color = d3.scaleSequential(function(s) {
                    return d3.interpolateRainbow(s/100);
                  }),
                  xScale = d3.scaleLinear()
                             .domain([0, d3.max(data, function(d) {
                               return d.value;
                             })])
                             .range([0, width]),
                  maxValue;

              maxValue = data[0].value;
              for (var i in data) {
                if (data[i].value > maxValue)
                  maxValue = data[i].value;
              }

              svg.attr('height', height);

              svg.selectAll('rect')
                .data(data)
                .enter()
                  .append('rect')
                  .attr('height', barHeight)
                  .attr('width', function(d) {
                      return xScale(maxValue);
                  })
                  .attr('x', 0)
                  .attr('y', function(d,i) {
                    return i * (barHeight + barPadding) + 25;
                  })
                  .attr('fill', function(d) {
                    return 'rgb(65,157,176)';
                    // if (scope.src === 'turnover')
                    //   return 'rgb(65,157,176)';
                    // else
                    //   color(d.value);
                  })
                  // .on('click', function(d, i) {
                  //   return scope.onClick(d);
                  // })
                  .transition()
                    .duration(1000)
                    .attr('width', function(d) {
                      if (maxValue === 0)
                        return width;
                      else
                        return xScale(d.value);
                    });

              var texts = svg.selectAll("text")
                              .data(data)
                              .enter();

              texts.append("text")
                    .attr('fill', '#222')
                    .attr('y', function(d,i) {
                      return i * (barHeight + barPadding)+20;
                    })
                    .attr('x', 0)
                    .text(function(d) {
                      return d.title;
                    })
                    .style('font-size', '12px');

              texts.append("text")
                    .attr('fill', '#222')
                    .attr('y', function(d,i) {
                      return i * (barHeight + barPadding)+20;
                    })
                    .attr('x', function(d, i) {
                      return width;
                    })
                    .attr('dx', function(d, i) {
                      var c;
                      if (scope.src === 'turnover')
                        c = $filter('number')(d.value, 2).toString().length * 6;
                      else 
                        c = d.value.toString().length * 6;

                      return -c-3;
                    })
                    .text(function(d) {
                      return scope.src === 'turnover' ? $filter('number')(d.value, 2) : d.value;
                    })
                    .attr('class', 'bold')
                    .style('font-size', '12px');

            }, 100);
          };
        });
      }};
  }]);
